/**
 * Panel definitions for forward/coal commodity
 * Add your coal-related panels here based on backend dataset configs
 */
export const forwardCoalPanels = [
  // First row: 2 panels side-by-side (12 cols each)
  {
    id: 'coal-forward-curve',
    type: 'datasetChart',
    datasetId: 'ice-cals-rotterdam-coal',
    visualizationId: 'cals-rotterdam-coal-forward-curve',
    labelOverrides: { descriptionKey: 'dashboard_panels.coal_forward_curve' },
    gridPos: { x: 0, y: 0, w: 8, h: 14 },
  },
  {
    id: 'coal-monthly-settlements',
    type: 'datasetChart',
    datasetId: 'ice-cals-rotterdam-coal',
    visualizationId: 'cals-rotterdam-coal-monthly-settlements',
    gridPos: { x: 8, y: 0, w: 8, h: 14 },
  },

  // Second row: 1 panel full width (24 cols)
  {
    id: 'coal-front-month',
    type: 'datasetChart',
    datasetId: 'ice-cals-rotterdam-coal',
    visualizationId: 'cals-rotterdam-coal-front-month-daily',
    gridPos: { x: 16, y: 0, w: 8, h: 14 },
  },
];

export const forwardCoalSyncGroups = [
  {
    id: 'coal-first-row',
    global: false,
    ids: ['coal-forward-curve', 'coal-monthly-settlements', 'coal-front-month'],
    syncAxes: { y: true },
  },
];
